'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var index = require('../theme/index.js');
var react = require('@chakra-ui/react');

/**
 * extendTheme
 *
 * Function to override or customize the design system theme conveniently.
 * First extension overrides the baseTheme and following extensions override the preceding extensions.
 *
 * @example:
 * const customTheme = extendTheme(
 *   {
 *     colors: {
 *       red: {
 *         400: "#b4d455",
 *       },
 *     },
 *   },
 * )
 *
 */
var extendTheme = function extendTheme() {
  for (var _len = arguments.length, overrides = new Array(_len), _key = 0; _key < _len; _key++) {
    overrides[_key] = arguments[_key];
  }
  return react.mergeThemeOverride.apply(void 0, [index["default"]].concat(overrides));
};
exports["default"] = extendTheme;